
function Logo() {
	return (
		<div className="Logo left font-logo align-items-center align-middle">
			<span className="align-middle"><img src={"logo192.png"} className="App-logo" alt="logo" height="50em" /></span> 
			<span className="align-middle h3 text-primary font-logo">Cardenalito</span>
		</div>
	);
}

export default Logo;